import { Box, Container, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import ExpertItems from "./ExpertItems";
import * as expertTechData from "../Services/textBody";

const useStyles = makeStyles({
  componentTitle: {
    "&.MuiTypography-root": {
      fontFamily: "Rajdhani, sans-serif",
      fontWeight: "500",
      fontSize: "3rem",
      textAlign: "end",
      lineHeight: "5.3rem",
    },
  },
  skillGroup: {
    marginBottom: "5rem",
  },
});
function ExpertTechno() {
  const classes = useStyles();
  return (
    <>
      <Container maxWidth="sm">
        {expertTechData.expertTechnology.map((item) => (
          <div key={item.id} className={classes.skillGroup}>
            <Typography
              variant="h3"
              component="div"
              className={classes.componentTitle}
            >
              {item.title}
            </Typography>
            <Box component="div">
              <ExpertItems componentSkill={item.component} />
            </Box>
          </div>
        ))}
      </Container>
    </>
  );
}

export default ExpertTechno;
